<template>
  <div>
    <div class="header-video">
      <img :src="loadUrl.studio_banner" />
      <div class="video-text">
        <div class="logo-text">
          <span>混空</span>
          <span>VPS</span>
        </div>
        <div class="link-room">混空VPS（Visual Positioning System）由公司自主研发，是一款融合多源数据和AI视觉算法，提供高精度定位和环境感知，帮助开发者快速部署XR沉浸式体验的定位系统。</div>
      </div>
    </div>
    <div class="role-wrap">
      <div class="title">为您构建室内外稳定的<span style="color: #822EFF;">空间计算能力</span></div>
      <div class="role-scene">
        <div>
          <div class="item" v-for="item in modelTypes[MODEL]" :key="item.header">
            <img :src="item.image" alt="">
            <div class="content">
              <h3>{{ item.header }}</h3>
              <ul>
                <li v-for="remark in item.remarkList" :key="remark">{{ remark }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wmdys">
      <div class="title">我们的优势</div>
      <div class="wmdys-content">
        <div class="left">
          <header>
            <img src="@/assets/images/ar-images/icon/cbys-icon2.png" class="l-iamge" alt="">
            <div class="r-head">成本优势</div>
          </header>
          <div class="line">· 技术使用成本低；</div>
          <div class="line">· 云SAAS化服务降低使用门槛。</div>
        </div>
        <div class="right" style="padding-right: 19rem;box-sizing: border-box;">
          <header>
            <img src="@/assets/images/ar-images/icon/cjys-icon2.png" class="l-iamge" alt="">
            <div class="r-head">场景优势</div>
          </header>
          <div class="line">· 现实空间三维建图、复杂环境感知、视觉导航上优势显著；</div>
          <div class="line">· 在城市级别大空间和复杂环境定位上优势显著，如商业广场、博物馆、历史遗迹等；</div>
          <div class="line">· 在机器人、自动驾驶、医疗、消费电子等领域具备可拓展前景。</div>
        </div>
      </div>
    </div>
    <!-- <div class="wmdys">
      <div class="title">我们的优势</div>
      <img src="@/assets/images/studio/wmdys-c1.png"/>
      <img src="@/assets/images/studio/wmdys-c2.png"/>
    </div> -->
    <!-- <div class="yycj">
      <div class="title">应用场景</div>
      <div>
        <img src="@/assets/images/studio/yycj-text.png" />
        <img src="@/assets/images/studio/yycj-pic.png" />
      </div>
    </div> -->
    <div class="yycj">
      <div class="title deep">应用场景</div>
      <div class="scene-list-box">
        <div class="type-list">
          <div v-for="item in sceneTypeList" :key="item">{{ item }}</div>
        </div>
        <div class="scene-list">
          <img src="@/assets/images/ar-images/icon/yycj-vps1.png" />
          <img src="@/assets/images/ar-images/icon/yycj-vps2.png" />
          <img src="@/assets/images/ar-images/icon/yycj-vps3.png" />
          <img src="@/assets/images/ar-images/icon/yycj-vps4.png" />
        </div>
      </div>
    </div>
    <div class="sljs">
      <div class="title">实例介绍</div>
      <img :src="loadUrl.qyzt"/>
      <div class="title-sub">企业展厅空间采集演示</div>
      <img :src="loadUrl.scdkj"/>
      <div class="title-sub">商场大空间采集演示</div>
    </div>
    <div class="package">
      <div>
        <div class="title deep">按需选择 灵活购买</div>
        <div class="title-tips deep">混空VPS产品体系</div>
        <div class="package-list">
          <div>
            <!-- <div class="img-div">
              <img src="@/assets/images/studio/youbingfa.png"/>
              <div class="btn" @click="router.push('/counselling')">立即咨询</div>
            </div>
            <div class="img-div">
              <img src="@/assets/images/studio/wubingfa.png"/>
              <div class="btn" @click="router.push('/counselling')">立即咨询</div>
            </div> -->
            <div class="img-div">
              <div>有并发要求</div>
              <div class="suv-title2">标准服务包含</div>
              <div class="service-content">
                <div>
                  <span>定位面积</span>
                  <span>定位服务时长</span>
                  <span>并发数量</span>
                  <span>技术支持</span>
                </div>
              </div>
              <div class="contact-tips">可根据您的项目实际情况，购买标准服务(支持按需扩展单项)</div>
              <div class="contact-btn" @click="router.push('/counselling')">立即咨询</div>
            </div>
            <div class="img-div">
              <div>无并发要求</div>
              <div class="suv-title2">标准服务包含</div>
              <div class="service-content">
                <div>
                  <span>定位面积</span>
                  <span>定位服务时长</span>
                  <span>技术支持</span>
                </div>
              </div>
              <div class="contact-tips">可根据您的项目实际情况，购买标准服务(支持按需扩展单项)</div>
              <div class="contact-btn" @click="router.push('/counselling')">立即咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, watch, onUnmounted } from 'vue';
import { asynchronousRetrieval } from '@/utils';
import router from '@/router';
import { modelTypes } from '@/config';

const sceneTypeList = ['工业设计', '教育培训', '文博场馆', '城市规划', '停车场', '景区公园', '体育赛事', '商业街区', '历史遗迹', '演唱会', '科技馆', '旅游导览', '活动晚会', '娱乐体验', '大型会展', '智慧工厂']
const MODEL = 'vision_ar_vps'
const loadUrl: any = ref({})

onMounted(async () => {
  const studio_banner: any = await asynchronousRetrieval('webimg/images/vps-img.png');
  const qyzt: any = await asynchronousRetrieval('webimg/gif/qyzt.gif');
  const scdkj: any = await asynchronousRetrieval('webimg/gif/scdkj.gif');
  loadUrl.value = { studio_banner, qyzt, scdkj }
})
</script>
<style scoped lang="less">
.header-video {
  position: relative;
  width: 100%;
  height: 336rem;
  position: relative;
  background-size: 100% 100%;
  background: linear-gradient( 180deg, #A837F7 0%, #5108BD 100%);

  img {
    height: 100%;
    object-fit: fill;
    position: absolute;
    right: 40rem;
    top: 0;
  }

  .video-text {
    width: 1120rem;
    position: absolute;
    top: 50rem;
    left: 62rem;
    font-size: 20rem;
    color: #FFFFFF;
    text-align: left;

    .logo-text {
      font-weight: 600;
      font-size: 40rem;
      color: #FFFFFF;
    }

    .link-room {
      font-size: 20rem;
      color: #FFFFFF;
      margin-top: 10rem;
      width: 298rem;
      font-weight: 400;
    }

    .experience-now {
      margin-top: 58rem;
      width: 160rem;
      height: 50rem;
      background: #0675FF;
      border-radius: 25rem;
      padding: 0 6rem 0 16rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      color: #fff;
      font-size: 24rem;

      .experience-btn {
        width: 38rem;
        height: 38rem;
        background: url(~@/assets/images/next-icon.png);
        background-size: 100% 100%;
      }
    }
  }
}

.role-wrap {
  width: 100vw;
  background: #E1E5FF;
  padding-top: 48rem;

  .title {
    font-weight: bold;
    font-size: 40rem;
    color: #414141;
    margin-bottom: 32rem;
  }

  .title-tips {
    font-weight: 400;
    font-size: 24rem;
    color: #FFFFFF;
    margin-bottom: 40rem;
  }

  .role-scene {
    width: 100%;
    overflow: hidden;
    overflow-x: auto;

    &>div {
      width: 1624rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 64rem 48rem;

      &>div {
        width: 388rem;
        height: 570rem;

        img {
          width: 100%;
          height: auto;
        }

        width: 388rem;
        background: #FFFFFF;
        border-radius: 12rem;

        img {
          width: 388rem;
          height: auto;
        }

        .content {
          box-sizing: border-box;
          padding: 32rem 34rem 0;

          h3 {
            font-weight: 500;
            font-size: 28rem;
            color: #333333;
            margin-bottom: 20rem;
            text-align: left;
            box-sizing: border-box;
            padding-left: 1rem;
            margin-top: 0;
          }
          

          ul {
            padding-left: 20rem;

            li {
              position: relative;
              list-style-type: none; /* 移除默认的点位 */
              font-weight: 400;
              font-size: 20rem;
              color: #5C5C5C;
              text-align: left;
              line-height: 1.8;
              // text-align: justify;

              &::before {
                content: '';
                width: 8rem;
                height: 8rem;
                border-radius: 100% 100%;
                position: absolute;
                left: -17rem;
                top: 12rem;
                background-color: #5C5C5C;
              }
            }
          }
        }
      }
    }
  }
}

.wmdys {
  width: 100%;
  height: 720rem;
  background-image: url(~@/assets/images/ar-images/aurora-bg.png);
  background-size: 100% 100%;
  padding: 48rem 0 0 0;
  box-sizing: border-box;

  .title {
    font-weight: bold;
    font-size: 40rem;
    color: #FFF;
    margin-bottom: 40rem;
  }

  .wmdys-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .left,
    .right {
      width: 624rem;
      height: 198rem;
      border-radius: 12rem;
      overflow: hidden;
      background: url('@/assets/images/ar-images/youshiback001.png') no-repeat;
      background-size: 100% 100%;

      header {
        display: flex;
        align-items: center;
        margin: 28rem 0 20rem 0;
        box-sizing: border-box;
        padding-left: 28rem;


        .l-iamge {
          width: 56rem;
          height: 54rem;
          margin-right: 20rem;
        }

        .r-head {
          font-weight: 500;
          font-size: 28rem;
          color: #414141;
        }
      }

      .line {
        font-size: 20rem;
        color: #5C5C5C;
        line-height: 1.5;
        text-align: left;
        box-sizing: border-box;
        padding-left: 28rem;
        margin-bottom: 6rem;
      }
    }

    .right {
      background: url('@/assets/images/ar-images/youshiback002.png') no-repeat;
      background-size: 100% 100%;
      height: 278rem;
      margin-top: 28rem;
    }
  }
}

.yycj {
  background-color: #EFEFEF;
  padding-top: 48rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 24rem;

  .title {
    font-weight: bold;
    font-size: 40rem;
    color: #414141;
    margin-bottom: 32rem;
  }

  .scene-list-box {
    width: 624rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    &>div {
      height: 622rem;
    }

    &>div:first-child {
      width: 430rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      font-size: 28rem;
      color: #4F4F4F;
      position: relative;
      top: -12rem;

      &>div:nth-child(2n) {
        margin-left: 12rem;
      }

      &>div {
        width: 206rem;
        height: 54rem;
        line-height: 54rem;
        background: rgba(255,255,255,0.64);
        border-radius: 4rem;
        text-align: center;
        margin: 12rem 0;
      }
    }

    .scene-list {
      width: 174rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      position: relative;
      top: -12rem;

      &>img {
        width: 174rem;
        height: auto;
        background-color: #fff;
        margin: 12rem 0;
        border-radius: 4rem;
      }
    }
  }
}

.sljs {
  background-color: #fff;
  padding-top: 48rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .title {
    font-weight: bold;
    font-size: 40rem;
    color: #414141;
    margin-bottom: 24rem;
  }

  .title-sub {
    font-weight: 500;
    font-size: 28rem;
    color: #414141;
    margin: 14rem 0 32rem;
  }

  img {
    width: 621rem;
    height: 349rem;
  }
}

.package {
  width: 100vw;
  padding-bottom: 62rem;
  background: linear-gradient( 180deg, #FFFFFF 0%, #E9EFF6 100%);

  &>div {
    padding-top: 80rem;

    .title {
      font-weight: 600;
      font-size: 40rem;
      color: #000000;
      line-height: 56rem;
      margin-bottom: 14rem;
    }

    .title-tips {
      font-weight: 500;
      font-size: 24rem;
      color: #5C5C5C;
      line-height: 34rem;
    }
  }

  .package-list {
    width: 100vw;
    margin-top: 30rem;
    overflow: hidden;
    overflow-x: auto;

    &>div {
      width: 1186rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 64rem;
      box-sizing: border-box;

      .img-div {
        position: relative;
        width: 514rem;
        height: 394rem;
        background: rgba(255,255,255,0.32);
        box-shadow: 0rem 4rem 19rem 0rem rgba(0,0,0,0.06);
        border-radius: 23rem 23rem 23rem 23rem;
        border: 1px solid rgba(0,0,0,0.1);
        padding: 32rem 0 0 32rem;
        box-sizing: border-box;

        &>div:first-child {
          font-weight: 600;
          font-size: 28rem;
          color: #000000;
          text-align: left;
          margin-bottom: 16rem;
        }

        .suv-title2 {
          font-weight: 600;
          font-size: 20rem;
          color: #000000;
          text-align: left;
          margin-bottom: 16rem;
        }

        .service-content {
          text-align: left;

          span {
            display: inline-block;
            font-weight: 400;
            font-size: 20rem;
            color: rgba(112, 46, 255, 1);
            text-align: center;
            padding: 6rem 11rem;
            background: rgba(112, 46, 255, 0.1);
            border-radius: 4rem;
            margin-right: 12rem;
            margin-bottom: 12rem;
          }
        }

        .function-box {
          font-weight: 400;
          font-size: 16rem;
          color: #4F4F4F;
          text-align: left;

          &>div {
            position: relative;
            margin-bottom: 12rem;
            padding-left: 22rem;

            &::before {
              content: '';
              width: 16rem;
              height: 16rem;
              background-image: url(~@/assets/images/studio/list-iconA.png);
              background-size: 100% 100%;
              position: absolute;
              left: 0;
              top: 4rem;
            }
          }
        }

        .contact-btn {
          width: 450rem;
          height: 80rem;
          line-height: 80rem;
          background: rgba(112, 46, 255, 1);
          border-radius: 8rem;
          font-weight: 500;
          font-size: 24rem;
          color: #FFFFFF;
          position: absolute;
          bottom: 72rem;
          left: 32rem;
          cursor: pointer;
        }

        .contact-tips {
          font-weight: 400;
          font-size: 16rem;
          color: #828282;
          position: absolute;
          bottom: 30rem;
          left: 0;
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}
</style>